import { useDonate } from '../donate-context';
import { useDonateValidation } from '../hooks/use-donate-validation';

export const DonateImpactText: React.FC = () => {
  const { state, props } = useDonate();
  const { getCurrentAmount } = useDonateValidation();
  const frequencyAmounts =
    props?.fund?.[`suggestedAmounts${state.donateFrequency}`];
  const impactText = frequencyAmounts?.find(
    (e) => e.value.toString() === getCurrentAmount(),
  )?.impact;

  return impactText && !state.otherSelected ? <p>{impactText}</p> : null;
};
